import { render, staticRenderFns } from "./ViewerFooter.vue?vue&type=template&id=b5425266&scoped=true"
import script from "./ViewerFooter.vue?vue&type=script&lang=js"
export * from "./ViewerFooter.vue?vue&type=script&lang=js"
import style0 from "./ViewerFooter.vue?vue&type=style&index=0&id=b5425266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5425266",
  null
  
)

export default component.exports